import { useEffect, useState } from 'react'
import {
  THEME_CHANGE_EVENT,
  readThemePreference,
  resolvedColorScheme,
  type ThemePreference,
} from '../../../utils/themePreference'

export type AppColorScheme = 'light' | 'dark'

function readColorScheme(): AppColorScheme {
  return resolvedColorScheme(readThemePreference())
}

/** Thème UI clair/sombre résolu (header, data-theme / prefers-color-scheme). */
export function useAppColorScheme(): AppColorScheme {
  const [scheme, setScheme] = useState<AppColorScheme>(() => readColorScheme())

  useEffect(() => {
    const root = document.documentElement
    const sync = () => setScheme(readColorScheme())

    const observer = new MutationObserver(sync)
    observer.observe(root, { attributes: true, attributeFilter: ['data-theme'] })

    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    mq.addEventListener('change', sync)
    window.addEventListener('storage', sync)
    window.addEventListener(THEME_CHANGE_EVENT, sync)

    return () => {
      observer.disconnect()
      mq.removeEventListener('change', sync)
      window.removeEventListener('storage', sync)
      window.removeEventListener(THEME_CHANGE_EVENT, sync)
    }
  }, [])

  return scheme
}

export type { ThemePreference }
